import auth from '../middleware/auth';
import requiresPasswordChange from "../middleware/user-password-change";

export default {
    path: 'dokumenti/:documentId',
    name: 'single-document-view',
    meta: {
        middleware: [auth, requiresPasswordChange],
    },
    component: () => import('@/views/site/Document'),
}